module.exports = __webpack_public_path__ + "images/emoji/arrow_up.00f77f95af24ba5f8ad6.png";